import { defineComponent as _defineComponent } from 'vue'
import { Pill, PillColor, Typo } from '@travelata-libs/ui-kit';
    import { RouteRecomendation } from '../types';

    interface RecomendationPillProps {
        value: RouteRecomendation | null,
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'RecomendationPill',
  props: {
    value: null
  },
  setup(__props: any) {

    

    const data: Record<RouteRecomendation, { text: string, color: PillColor }> = {
        [RouteRecomendation.Cheap]: {
            text: 'Самый дешёвый',
            color: PillColor.Green,
        },
        [RouteRecomendation.Direct]: {
            text: 'Дешёвый прямой',
            color: PillColor.Purple,
        },
        [RouteRecomendation.Connection]: {
            text: 'Дешёвый с удобной пересадкой',
            color:  PillColor.Sky,
        }
    }


return { __sfc: true,data, Pill, Typo }
}

})